<ng-container *ngIf="!user">
  <app-spinner></app-spinner>
</ng-container>
<ng-container *ngIf="user">
  <tyt-tabs>
    <tyt-tab id="general" label="General">
      <div class="account-info">
        <div>
          <label class="key">Email Address:</label>
          {{ user.email }}
          <a class="change-link" routerLink="/settings/account/change-email">Change</a>
        </div>
        <div>
          <label class="key">Username:</label>

          <ng-container *ngIf="user.username">
            {{ user.username }}
          </ng-container>
          <ng-container *ngIf="!user.username">
            Not set
            <a class="change-link" routerLink="/settings/account/change-username">Choose a username</a>
          </ng-container>
        </div>

        <div>
          <label class="key">Password:</label>

          <ng-container *ngIf="user.missing_password">
            Not set <a class="change-link" routerLink="/settings/account/change-password">Create a password</a>
          </ng-container>

          <ng-container *ngIf="!user.missing_password">
            ******
            <a class="change-link" routerLink="/settings/account/change-password">Change</a>
          </ng-container>
        </div>

        <div>
          <label class="key">Signed up:</label>
          {{ user.created_at | date }}
        </div>
      </div>
    </tyt-tab>
    <tyt-tab id="connected-accounts" label="Connected Accounts">
      <div class="account-info">
        <ng-container *ngIf="user && user.omniauths && user.omniauths.length > 0">
          <br />
          <br />
          <h3>Connected Accounts</h3>

          <div class="connected-accounts">
            <div class="connected-account" [ngClass]="account.provider" *ngFor="let account of user.omniauths">
              <i class="fab fa-{{account.provider}}"></i>
              <div>
                <div class="account-name">{{(nicknameForConnectedAccount(account))}}</div>

                <ul class="fact-list">
                  <li>{{platformNameForProvider(account.provider)}}</li>
                  <li *ngIf="shouldShowEmail(account)">{{account.email}}</li>
                  <li>
                    <a href="javascript:;" (click)="removeConnectedAccount(account)">Remove</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-container>

        <br />
        <br />

        <h3>Connect an Account</h3>

        <div class="connected-accounts connect-new">
          <a href="javascript:;" (click)="connectWithProvider(provider.id)" class="connected-account"
            [ngClass]="provider.id" *ngFor="let provider of availableAccountProviders">
            <i class="fab fa-{{provider.id}}"></i>
            <div>
              <div class="account-name">{{(platformNameForProvider(provider.id))}}</div>
            </div>
          </a>
        </div>
      </div>
    </tyt-tab>
    <tyt-tab id="payment-history" *ngIf="enablePaymentHistory" label="Payment History" (selected)="loadTransactions()">
      <ng-container *ngIf="!transactions">
        <app-spinner></app-spinner>
      </ng-container>

      <ng-container *ngIf="transactions">
        <table class="transactions-list">
          <thead>
            <tr>
              <th style="width: 2em"></th>
              <th style="width: 8em">Date</th>
              <th style="width: 8em">Amount</th>
              <th style="width: 12em">Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let txn of transactions" [class.failed]="txn.failed">
              <td>
                <mat-icon class="error" *ngIf="txn.failed">close</mat-icon>
                <ng-container *ngIf="!txn.failed">
                  <ng-container *ngIf="transactionKey(txn) === 'payment/join'">
                    🎉
                  </ng-container>
                </ng-container>
              </td>

              <td>{{txn.source_timestamp | date : 'shortDate'}}</td>
              <td>{{txn.price / 100 | currency : 'USD'}}</td>
              <td>{{displayTypeOfTransaction(txn)}}</td>
              <td>
                {{txn.description}}
              </td>
            </tr>
          </tbody>

        </table>
      </ng-container>

      <p>
        Note: One-time donations do not accumulate towards membership benefits over time, and membership benefits can
        only be granted at the time of payment, based on amount contributed. We can’t reflect your membership
        payment history for Paypal or YouTube (even if you've connected your YouTube Channel Membership).
      </p>
    </tyt-tab>
  </tyt-tabs>
</ng-container>